import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { ApiGatewayUrl } from '../appsettings';
import ErrorException from "src/components/ErrorException";
import Rest from '../core/rest';
import _ from 'lodash';

export const filterCameras = createAsyncThunk(
  'camera/filterCameras',
  async (request) => {
    try {
      let gpIds = '';
      let pcyList = '';
      let controlList = '';

      if (request.video_sensor_gp_ids.length > 0) { gpIds = request.video_sensor_gp_ids.join(','); }
      if (request.privacy.length > 0) { pcyList = request.privacy.join(','); }
      if (request.controls.length > 0) { controlList = request.controls.join(','); }

      const response = await Rest.get(
        ApiGatewayUrl +
        '/videosensors/filter?page=' + request.page +
        '&rows_per_page=' + request.rows_per_page +
        '&agency_id=' + request.agency_id +
        '&filter_text=' + request.filter_text +
        '&cameragp_ids=' + gpIds +
        '&privacy=' + pcyList +
        '&controls=' + controlList
      );
      return response.data;
    }
    catch (ex) {
      ErrorException(ex.response);
    }
  }
);

export const getCamInfoById = createAsyncThunk(
  'camera/getCamInfoById',
  async (id) => {
    try {
      const response = await Rest.get(
        ApiGatewayUrl + '/videosensors/' + id);
      return response.data;
    }
    catch (ex) {
      ErrorException(ex.response);
    }
  }
);

export const editTags = createAsyncThunk(
  'camera/editTags',
  async (editTagsRequest) => {
    try {
      const response = await Rest.put(
        ApiGatewayUrl + '/videosensors/editTags?video_sensor_id=' + editTagsRequest.video_sensor_id
        + '&tags=' + editTagsRequest.tags);
      return response.data;
    }
    catch (ex) {
      ErrorException(ex.response);
    }
  }
);

export const editCamera = createAsyncThunk(
  'camera/editCamera',
  async (editCameraRequest) => {
    try {
      const response = await Rest.put(ApiGatewayUrl + '/videosensors', editCameraRequest);
      return { response: response.data, editCameraRequest };
    }
    catch (ex) {
      ErrorException(ex.response);
    }
  }
);

export const makePublic = createAsyncThunk(
  'camera/makePublic',
  async (cameraIds) => {
    try {
      const response = await Rest.put(ApiGatewayUrl + '/videosensors/makePublic', cameraIds);
      return { response: response.data, cameraIds };
    }
    catch (ex) {
      ErrorException(ex.response);
    }
  }
);

export const makeRestricted = createAsyncThunk(
  'camera/makeRestricted',
  async (cameraIds) => {
    try {
      const response = await Rest.put(ApiGatewayUrl + '/videosensors/makeRestricted', cameraIds);
      return response.data;
    }
    catch (ex) {
      ErrorException(ex.response);
    }
  }
);
export const syncAllCameraFromAgency = createAsyncThunk(
  'camera/syncAllCameras',
  async (agency) => {
    try {
      const response = await Rest.post(ApiGatewayUrl + '/synccameras/' + agency);
      return response.data;
    }
    catch (ex) {
      ErrorException(ex.response);
    }
  }
);


export const addCamerasToGroup = createAsyncThunk(
  'camera/addCamerasToGroup',
  async (requestInfo) => {
    try {
      const response = await Rest.put(ApiGatewayUrl + '/videosensors/addToGroup', requestInfo);
      return response.data;
    }
    catch (ex) {
      ErrorException(ex.response);
    }
  }
);

export const cameraSlice = createSlice({
  name: 'camera',
  initialState: {
    isMultiUpdating: false,
    isSaving: false,
    errorMsg: '',
    cameras: [], 
    videoSensorGps: [],
    privacyList: [],
    controlList: [],
    total: 0,
    selectedAgencyId: 0,
    selectedVideoSensorGpIds: [],
    selectedPivacyList: [],
    selectedControlList: [],
    filteredText: '',
    isEditing:false,
    changed: false,
    isEditingTag: false
  },
  reducers: {
    saveSelectedAgencyId: (state, action) => {
      state.selectedAgencyId = action.payload;
    },
    saveFilterText: (state, action) => {
      state.filteredText = action.payload;
    },
    saveSelectedGpIds: (state, action) => {
      state.selectedVideoSensorGpIds = action.payload;
    },
    saveSelectedPrivacyList: (state, action) => {
      state.selectedPivacyList = action.payload;
    },
    saveSelectedControlList: (state, action) => {
      state.selectedControlList = action.payload;
    },
    saveCameraList: (state, action) => {
      state.cameras = action.payload;
    },
    saveChangedState: (state, action) => {
      state.changed = action.payload;
    },
    saveIsEditing: (state, action) => {
      state.isEditing = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(filterCameras.fulfilled, (state, action) => {
        let c = _.map(action.payload.camreas, (x) => {
          return {
            video_sensor_id: x.video_sensor_id,
            video_sensor_name: x.video_sensor_name,
            video_sensor_group_id: x.video_sensor_group_id,
            privacy: x.privacy,
            is_controllable: x.is_controllable,
            tags: x.tags,
            loc_lat: x.loc_lat,
            loc_long: x.loc_long,
            live_view: x.live_view
          };
        });
        return {
          ...state,
          cameras: c,  
          videoSensorGps: action.payload.videoSensorGps,
          privacyList: action.payload.privacyList,
          controlList: action.payload.controlList,
          total: action.payload.total
        };
      })
      .addCase(editCamera.pending, (state) => {
        return { ...state, isSaving: true };
      })
      .addCase(editCamera.fulfilled, (state, action) => {
        let newList = [...state.cameras];
        let editedData = { ...action.payload.editCameraRequest }
        const findIdx = newList.findIndex(x => x.video_sensor_id === editedData.video_sensor_id);
        newList[findIdx] = { ...editedData };
        return {
          ...state,
          isSaving: false,
          cameras: newList
        };
      })
      .addCase(editCamera.rejected, (state, action) => {
        return {
          ...state,
          errorMsg: action.error.message,
          isSaving: false
        };
      })
      .addCase(makePublic.pending, (state) => {
        return { ...state, isMultiUpdating: true };
      })
      .addCase(makePublic.fulfilled, (state) => {
        return {
          ...state,
          isMultiUpdating: false
        };
      })
      .addCase(makeRestricted.pending, (state) => {
        return { ...state, isMultiUpdating: true };
      })
      .addCase(makeRestricted.fulfilled, (state) => {
        return {
          ...state,
          isMultiUpdating: false
        };
      })
      .addCase(addCamerasToGroup.pending, (state) => {
        return { ...state, isMultiUpdating: true };
      })
      .addCase(addCamerasToGroup.fulfilled, (state) => {
        return {
          ...state,
          isMultiUpdating: false
        };
      })
      .addCase(editTags.pending, (state) => {
        return { ...state, isEditingTag: true };
      })
      .addCase(editTags.rejected, (state) => {
        return { ...state, isEditingTag: true };
      })
      
    builder.addCase(editTags.fulfilled, (state) => {
      return {
        ...state,
        isEditingTag: false
      };
    });

  }
});

export const cameraActions = cameraSlice.actions;
export const cameraState = (state) => state.camera;
export default cameraSlice.reducer;
